const Card=({children,className})=>{
    return  <div className={`w-full p-3 bg-white ${className}`}>
                {children}
            </div>
}
export default Card;